import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export function convertIsoToPlotlyFormat(isoString: string) {
  return dayjs.utc(isoString).local().format('YYYY-MM-DD HH:mm:ss.SSS');
}

export function addLocalOffsetAndFormatToLocalString(
  datestring: string,
  factor = 1
) {
  const newdate = new Date(datestring);
  newdate.setTime(
    newdate.getTime() - newdate.getTimezoneOffset() * 60 * 1000 * factor
  );
  return newdate.toISOString().replace('T', ' ').replace('Z', '');
}
